module.exports = __webpack_public_path__ + "media/images/favicon/apple-icon-72x72-839eed4e4d8fd835d709895395dcfcfb.png";